// Service Worker Helper

const SWHelper = {
  async getWaitingWorker() {
    const registrations = (await navigator?.serviceWorker?.getRegistrations()) || [];
    const registrationWithWaiting = registrations.find(reg => reg.waiting);
    return registrationWithWaiting?.waiting;
  },

  async skipWaiting() {
    //return (await SWHelper.getWaitingWorker())?.postMessage({ type: 'SKIP_WAITING_WHEN_SOLO' });
    return (await SWHelper.getWaitingWorker())?.postMessage({ type: 'SKIP_WAITING' });
  },

  async prepareCachesForUpdate() {
    return (await SWHelper.getWaitingWorker())?.postMessage({ type: 'PREPARE_CACHES_FOR_UPDATE' });
  },

  async newServiceWorkerUpdated() {
    return (await SWHelper.getWaitingWorker())?.postMessage({ type: 'NEW_SERVICE_WORKER_UPDATED' });
  },
};

export default SWHelper;